/* tab-menu logic borrowed from saka website */
class Tab {
  constructor(tab, tabContent, active = false, languageLinks) {
    this.active = active;
    this.canDeactivate = false; //@todo
    this.tabId = tabContent.dataset.tabId;
    this.tabGroup = tabContent.dataset.tabGroup;
    this.tabButtons = tab;
    this.tabContent = tabContent;
    this.languageLinks = languageLinks;
    this.bindEvents();
  }

  bindEvents() {
    const self = this;
    for (const tab of this.tabButtons) {
      tab.addEventListener('click', function () {
        return self.active && self.canDeactivate ? self.deactivate(true) : self.activate(tab);
      });

      //add event listener to enter or space key
      tab.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          return self.active && self.canDeactivate ? self.deactivate(true) : self.activate(tab);
        }
      });
    }
  }

  activate(tabButton) {
    if (tabButton.classList.contains('disabled')) {
      return false;
    }
    for (const tab of window.tabs) {
      if (tab.tabGroup === tabButton.dataset.tabGroup) tab.deactivate();
    }
    for (const tabButton of this.tabButtons) {
      tabButton.classList.add('active');
    }
    this.tabContent.classList.add('active');

    this.tabContent.dispatchEvent(new Event('tab-activate'));

    this.active = true;
    this.updateLanguageLinks(this.tabContent.dataset.tabId);

    return true;
  }

  deactivate(manual = false) {
    for (const tab of this.tabButtons) {
      tab.classList.remove('active');
    }
    this.tabContent.classList.remove('active');

    this.active = false;

    if (manual) {
      this.updateLanguageLinks();
    }

    return true;
  }

  updateLanguageLinks(tabId = '') {
    if (this.languageLinks) {
      for (const link of this.languageLinks) {
        const hashIndex = link.href.indexOf('#');

        if (hashIndex >= 0) {
          link.href = link.href.substring(0, hashIndex);
        }

        if (tabId) {
          link.href += '#' + tabId;
        }
      }
    }
  }
}

class TabMenu {
  constructor() {
    this.tabElements = document.getElementsByClassName('tab-button');
    this.tabContentElements = document.getElementsByClassName('tab-content');

    /*
    const languageLinkList = document.getElementById('navigation-language-links');
    this.languageLinks = languageLinkList ? languageLinkList.getElementsByTagName('a') : false;
    */
    if (this.tabElements.length) {
      window.tabs = [];
      this.createTabs();
      /*
      window.addEventListener('load', function() {
        for (const tab of window.tabs) {

          if ('#' + tab.tabContent.dataset.tabId === window.location.hash) {
            tab.activate(tab.tabButtons[0]);
            break;
          }

        }
      });
    */
    }
  }

  createTabs() {
    for (const tabContent of this.tabContentElements) {
      const tabButtons = [];
      for (const tab of this.tabElements) {
        if (tab.dataset.tabId === tabContent.dataset.tabId) {
          tabButtons.push(tab);
        }
      }
      window.tabs.push(new Tab(tabButtons, tabContent, false, this.languageLinks));
    }
  }
}

module.exports = new TabMenu();
